import { makeStyles, createStyles } from '@material-ui/core/styles';

import { variables } from '@styles';

/**
 * DivContainer component styles
 * @returns {Function}
 */

export const useStyles = makeStyles((theme) =>
  createStyles({
    topSection: {
      marginBottom: theme.spacing(1),
    },

    caption: {},

    titleWrapper: {
      flex: '0 0 auto',
      padding: '0 1.6rem 2rem 1.6rem',
    },

    title: {
      alignItems: 'center',
      color: `${variables.colorV2.text.header}`,
      display: 'flex',
      fontSize: '2rem',
      fontWeight: 400,
      lineHeight: '2.5rem',
      justifyContent: 'space-between',
      // paddingBottom: '1rem',
    },

    divContainer: {
      backgroundColor: 'transparent',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',

      '&[data-ui-type=primary]': {
        paddingBottom: theme.spacing(2),

        '& $topSection': {
          marginBottom: theme.spacing(2),
        },

        '& $caption': {
          marginBottom: theme.spacing(1),
        },
      },

      '& .MuiAccordion-root': {
        marginBottom: '2rem',
      },
    },

    panel: {
      background: variables.colorV2.panel.background.default,
      borderRadius: '2rem',
      flex: '0 1 auto',
      padding: '2rem 1.6rem',
      overflowY: 'hidden',
    },

    panelContent: {
      height: '100%',
      overflowY: 'auto',
    },

    imageSrcWrapper: {
      display: 'flex',
      alignItems: 'center',
    },

    imageSrc: {
      width: '100%',

      '& input': {
        height: '3rem',
      },
    },

    selectBtn: {
      marginLeft: theme.spacing(1),
      width: '6.5rem',
      height: '3.2rem',
    },

    deleteButton: {
      padding: theme.spacing(0.25),
      margin: theme.spacing(0, 1),
    },

    editModeContainer: {
      padding: '2rem 1.6rem 2rem 1.6rem',
    },

    buttonContainer: {
      display: 'flex',
      justifyContent: 'flex-start',
      // minWidth: '60rem',
      // width: '60rem',
    },

    save: {
      // marginLeft: 'auto',
      '&:disabled': {
        // backgroundColor: variables.color.primary.backgroundLighterGray,
        // border: `0.1rem solid ${variables.color.primary.lightGrayDarker}`,
        // color: variables.color.primary.lightGrayDarker,
      },
    },

    close: {
      '&&': {
        borderRadius: '3.2rem',
        fontWeight: 500,
        marginRight: '.8rem',
        // border: `1px solid ${variables.colorV2.button.contained.secondary.border.default}`,
        // color: variables.colorV2.button.contained.secondary.text.default,

        '&:hover': {
          // backgroundColor: variables.colorV2.button.contained.secondary.background.hover,
          // border: `1px solid ${variables.colorV2.button.contained.secondary.border.hover}`,
          // color: variables.colorV2.button.contained.secondary.text.hover,
        },
      },
    },
  }),
);
